<template>
  <div class="terms-outline">
    <p class="title">
      {{ $t(`terms.${region}.tenantTermOfUse.title`) }}
    </p>
    <TermSections
      :sections="termsSections"
      :level="1"
      indexDelimiter=""
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TermSections from './TermSections'

export default {
  name: 'TermsOfUse',
  components: { TermSections },
  computed: {
    ...mapGetters('regions', ['publicPathLastSelectedRegion']),
    region () {
      return this.publicPathLastSelectedRegion.name
    },
    termsSections () {
      return this.$t(`terms.${this.region}.tenantTermOfUse.sections`)
    },
  },
}
</script>

<style lang="scss" scoped>
.terms-outline {
  padding: 25px 45px 25px 5px;
  background: white;
  text-align: justify;
}
.title {
  text-decoration: underline;
  font-weight: bold;
}
@page {
  size: auto; /* auto is the initial value */
  /* this affects the margin in the printer settings */
  margin-top: 15mm;
  margin-bottom: 10mm;
  margin-left: 1.82mm;
  margin-right: 1.82mm;
}
</style>
